// Component for editing a clothing item
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

const EditCloth = () => {
    const { id } = useParams(); // Get cloth ID from URL parameters
    const [formData, setFormData] = useState({
      cloth_name: '',
      category: '',
      color: '',
      size: '',
      season: '',
      brand: '',
      material: '',
      pattern: '',
      sleeveLength: '',
      image_url: ''
    });
    const [file, setFile] = useState(null);
    const navigate = useNavigate();
  
    useEffect(() => {
      fetchCloth();
    }, []);

    const fetchCloth = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.error('No token found');
          return;
        }
  
        const response = await axios.get(`http://localhost:3000/api/clothes/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        console.log('Fetched cloth:', response.data);
        setFormData(response.data); // Pre-fill form data with the fetched cloth details
      } catch (error) {
        console.error('Error fetching cloth:', error.response ? error.response.data : error.message);
      }
    };
    
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value
      }));
  };

  const handleFileChange = (e) => {
      setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
      e.preventDefault();
      const data = new FormData();
      for (const key in formData) {
        data.append(key, formData[key]);
      }
      if (file) {
        data.append('image', file);
      }
      try {
        const response = await axios.put(`http://localhost:3000/api/clothes/${id}`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        navigate('/clothes'); // Redirect after update
      } catch (error) {
        console.error('Error updating clothing item:', error);
        alert('Error updating clothing item. Please try again.');
      }
  };

  return (
    <div className="edit-cloth-container">
      <h1 className="form-title"><strong>𝐸𝒹𝒾𝓉 𝒞𝓁𝑜𝓉𝒽</strong></h1>
      <form onSubmit={handleSubmit} className="cloth-form">
        <label className="form-label">
          <strong>Cloth Name*:</strong>
          <input type="text" name="cloth_name" value={formData.cloth_name} onChange={handleChange} placeholder="Enter cloth name" />
        </label>
        <label className="form-label">
          <strong>Category\-ies*:</strong>
          <input type="text" name="category" value={formData.category} onChange={handleChange} placeholder="e.g. T-Shirts, Pants..." />
        </label>
        <label className="form-label">
          <strong>Color\-s*:</strong>
          <input type="text" name="color" value={formData.color} onChange={handleChange} placeholder="At least one color" />
        </label>
        <label className="form-label">
          <strong>Size*:</strong>
          <input type="text" name="size" value={formData.size} onChange={handleChange} placeholder="e.g. L or Large" />
        </label>
        <label className="form-label">
          <strong>Season\-s*:</strong>
          <input type="text" name="season" value={formData.season} onChange={handleChange} placeholder="Winter, Summer, Autumn, Spring" />
        </label>
        <label className="form-label">
          <strong>Brand:</strong>
          <input type="text" name="brand" value={formData.brand} onChange={handleChange} placeholder="e.g. Nike, Adidas" />
        </label>
        <label className="form-label">
          <strong>Material:</strong>
          <input type="text" name="material" value={formData.material} onChange={handleChange} placeholder="e.g. Cotton, Polyester" />
        </label>
        <label className="form-label">
          <strong>Pattern:</strong>
          <input type="text" name="pattern" value={formData.pattern} onChange={handleChange} placeholder="e.g. Curduroy" />
        </label>
        <label className="form-label">
          <strong>Sleeve Length:</strong>
          <input type="text" name="sleeveLength" value={formData.sleeveLength} onChange={handleChange} placeholder="e.g. Long/short sleeve" />
        </label>
        <label className="form-label">
          <strong>Image*:</strong>
          <input type="file" name="image" onChange={handleFileChange} placeholder="Please upload a clear image of the cloth" />
        </label>
        {formData.image_url && (
          <div className="image-preview">
            <p><strong>Current Image:</strong></p>
            <img crossorigin="anonymous" src={`http://localhost:3000/${formData.image_url}`} width="300"/>
          </div>
        )}
        {file && (
          <div className="image-preview">
            <p><strong>New Image Preview:</strong></p>
            <img src={URL.createObjectURL(file)} width="300" alt="New cloth preview" />
          </div>
        )}
        <button type="submit" className="submit-btn"><i class="fa-solid fa-upload"></i> <strong>𝒰𝓅𝒹𝒶𝓉𝑒</strong></button>
      </form>
    </div>
  );
};

export default EditCloth;